import { Component, ChangeDetectionStrategy } from '@angular/core'
import { HeaderBlankComponent } from '../../../headers/components/header-blank/header-blank.component'

@Component({
    selector: 'app-layout-cta',
    imports: [HeaderBlankComponent],
    templateUrl: './layout-cta.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './layout-cta.component.scss',
})
export class LayoutCtaComponent {}
